import { Book } from "../types/Book";
import { API_URL } from "../utils";

export default async (query: string): Promise<Book[]> => {
	const result: Book[] = await (await fetch(`${API_URL}/books?query=${query}`, {
		credentials: 'include'
	})).json();

	return result;
};
